import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs/operators';
import { ScannableOrder } from '@app/services/orders/scannable-order';
import { ScanService } from '../../services/scan.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-select-scanned-order',
  templateUrl: './select-scanned-order.component.html',
  styleUrls: ['./select-scanned-order.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SelectScannedOrderComponent implements OnInit {
  @Input() orders: ScannableOrder[];
  selectedOrder: ScannableOrder = null;
  loading = false;

  selectForm = new UntypedFormGroup({
    orderId: new UntypedFormControl(undefined, [Validators.required]),
  });

  constructor(private scanService: ScanService) {}

  ngOnInit(): void {
    this.selectForm.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      this.selectedOrder = this.orders.find((order) => order.id === value.orderId);
    });
  }

  onSubmit(): void {
    this.loading = true;
    this.scanService
      .syncAndScanOrder(this.selectedOrder.id, this.selectedOrder.shippingId)
      .pipe(
        untilDestroyed(this),
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe((order) => {
        this.scanService.toggleScanOrderDialogOpened(this.selectedOrder);
        this.scanService.toggleScanSelectOrdersDialog(null);
      });
  }
}
